import { useQuery } from '@tanstack/react-query';

import { CustomizationTheme } from '@graylog/enterprise-api';

import AppConfig from 'util/AppConfig';
import type { CustomThemesColors } from 'theme/theme-types';

const fetchCustomColors = (fromAppConfig: boolean, defaultCustomColors: {}): Promise<CustomThemesColors> => {
  if (fromAppConfig) {
    return Promise.resolve(defaultCustomColors) as Promise<CustomThemesColors>;
  }

  return CustomizationTheme.getThemeOverrides() as Promise<CustomThemesColors>;
};

const useCustomThemeColors = (fromAppConfig = true) => {
  const defaultCustomColors = fromAppConfig ? AppConfig.customThemeColors() : null;
  const { data, isInitialLoading } = useQuery({
    queryKey: ['customization', 'colors'],
    queryFn: () => fetchCustomColors(fromAppConfig, defaultCustomColors),
    keepPreviousData: true,
    enabled: !fromAppConfig,
    initialData: defaultCustomColors as CustomThemesColors,
  });

  return { data, isInitialLoading };
};

export default useCustomThemeColors;
